import React from 'react';
import { useBuildComponentTypes } from '../../../../../contexts/BuildComponentTypesContext';
import { maintenanceTemplateApi } from '../../../../../api/maintenanceTemplateApi';
import { TemplateCostFormModal } from './shared';
import { CostUnit } from '../../../../Förvaltning/TemplatesEditor/types';
import { LibraryPickerModal } from '../../../../../Components/LibraryPickerModal';
import { lifetimeLibrary } from '../../../../../library/lifetimeLibrary';

interface EditTemplateCostModalProps {
    componentType: string;
    componentTypeName: string;
    currentCost: number;
    currentCostUnit: CostUnit;
    buildingKey: string;
    onClose: () => void;
}

/**
 * Modal for editing the template's base replacement cost.
 * Warning: Changes affect ALL components of this type.
 *
 * Requires admin privileges.
 */
export const EditTemplateCostModal: React.FC<EditTemplateCostModalProps> = ({
    componentType,
    componentTypeName,
    currentCost,
    currentCostUnit,
    buildingKey,
    onClose
}) => {
    const { refresh, getBaseType } = useBuildComponentTypes();

    const handleSave = async (cost: number, costUnit: CostUnit) => {
        await maintenanceTemplateApi.updateLifetimeCost(componentType, cost, costUnit, { source: 'draft', buildingKey });

        // Refresh the component types context; the plan follows the context
        await refresh();
    };

    return (
        <TemplateCostFormModal
            title="Ändra mallkostnad"
            warningMessage={
                <>
                    <strong>Obs!</strong> Ändringar här påverkar <strong>alla komponenter</strong> av typen "{componentTypeName}" som använder mallkostnad. Komponenter med anpassad schablon eller kostnad enligt offert påverkas inte.
                </>
            }
            costLabel="Ersättningskostnad"
            currentCost={currentCost}
            currentCostUnit={currentCostUnit}
            renderLibraryPicker={({ open, onClose: onPickerClose, onPick }) => (
                <LibraryPickerModal
                    config={lifetimeLibrary}
                    open={open}
                    onClose={onPickerClose}
                    onSelect={(libTemplate) => onPick(libTemplate.replacementCost, libTemplate.costUnit)}
                    currentBaseType={getBaseType(componentType)}
                />
            )}
            onSave={handleSave}
            onClose={onClose}
        />
    );
};
